import React, { useEffect, useRef, useState } from "react";
import { RxCaretDown } from "react-icons/rx";
import styled from "styled-components";

const CustomSelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

const LabelValueContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Label = styled.span`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.black};
`;

const Value = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.white};
`;

const SelectParent = styled.div`
  width: 100%;
  border-radius: 12px;
  border: 1px solid #2c2c2c;
  background: rgba(255, 255, 255, 0.05);
  color: ${({ theme }) => theme.white};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 16px;
  position: relative;
  height: 56px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: ${({ theme }) => theme.secondary || "#00C853"};
    background: rgba(255, 255, 255, 0.1);
  }

  .icon {
    transition: transform 0.2s ease;
    ${({ open }) => open && "transform: rotate(180deg);"}
  }
`;

const Options = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 100%;
  background: ${({ theme }) => theme.body};
  border: 1px solid #2c2c2c;
  border-radius: 12px;
  padding: 8px 0;
  z-index: 10;
  max-height: 240px;
  overflow-y: auto;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
`;

const Option = styled.div`
  padding: 12px 18px;
  font-size: 15px;
  cursor: pointer;
  color: ${({ theme }) => theme.white};
  transition: background 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.hover || "#333"};
  }
`;

const CustomSelector = ({ label, value, options, handleSelect }) => {
  const [selected, setSelected] = useState(
    options?.find((x) => x?.value === value)
  );
  const [toggleDropdown, setToggleDropdown] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setToggleDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  useEffect(() => {
    const match = options?.find((x) => x.value === value);
    if (match) setSelected(match);
  }, [value, options]);

  return (
    <CustomSelectorContainer ref={ref}>
      <LabelValueContainer>
        <Label>{label}</Label>
        <Value>{value}</Value>
      </LabelValueContainer>
      <SelectParent
        onClick={() => setToggleDropdown((prev) => !prev)}
        open={toggleDropdown}
      >
        <span>{selected?.label || "Select"}</span>
        <RxCaretDown className="icon" />
        {toggleDropdown && (
          <Options>
            {options?.map((option, index) => (
              <Option
                key={index}
                onClick={() => {
                  setSelected(option);
                  handleSelect && handleSelect(option);
                  setToggleDropdown(false);
                }}
              >
                {option.label}
              </Option>
            ))}
          </Options>
        )}
      </SelectParent>
    </CustomSelectorContainer>
  );
};

export default CustomSelector;
